"use strict";
/* globals module */
/**
 * @module notificationsSettingsClient
 * @description  Notifications Settings Client provides an easy way to consume  Notifications REST API end-points. In order to obtain needed routes `notificationsSettingsClient` uses `notificationsSettingsRoute`.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var inversify_1 = require("inversify");
var httpApi_1 = require("../../httpApi");
var _1 = require("./");
var NotificationsSettingsClient = /** @class */ (function () {
    function NotificationsSettingsClient(notificationsSettingsRoute, apiClient) {
        this.notificationsSettingsRoute = notificationsSettingsRoute;
        this.apiClient = apiClient;
    }
    Object.defineProperty(NotificationsSettingsClient.prototype, "routeDefinition", {
        get: function () {
            return this.notificationsSettingsRoute;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns a promise that is resolved once the get action has been performed. Success response returns the specified setting resource.
     * @method
     * @param provider The notification provider name.
     * @returns A promise that is resolved once the get action has been performed.
     * @example notificationsSettingsClient.get('<provider-name>')
                    .then(function (data) {
                        // perform success action here
                    },
                     function (response, status, headers, config) {
                         // perform error handling here
                    });
     */
    NotificationsSettingsClient.prototype.get = function (provider) {
        return this.apiClient.get(this.routeDefinition.get(provider));
    };
    /**
     * Returns a promise that is resolved once the update settings action has been performed; this action updates a settings resource. This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `notificationsSettingsRoute` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.updateParams(settings);
     * let uri = params['model'].links('put').href;
     * ```
     * @method
     * @param data The notification settings.
     * @returns A promise that is resolved once the update settings action has been performed.
     * @example // settings is a resource previously fetched using get action.
                    notificationsSettingsClient.update(settings)
                        .then(function (data) {
                            // perform success action here
                        },
                         function (response, status, headers, config) {
                             // perform error handling here
                        });
     */
    NotificationsSettingsClient.prototype.update = function (data) {
        return this.apiClient.put(this.routeDefinition.update(data), this.routeDefinition.updateParams(data));
    };
    var _a, _b;
    NotificationsSettingsClient = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(_1.TYPES.NotificationsSettingsRoute)),
        tslib_1.__param(1, inversify_1.inject(httpApi_1.httpTYPES.ApiClient)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof _1.NotificationsSettingsRoute !== "undefined" && _1.NotificationsSettingsRoute) === "function" ? _a : Object, typeof (_b = typeof httpApi_1.ApiClient !== "undefined" && httpApi_1.ApiClient) === "function" ? _b : Object])
    ], NotificationsSettingsClient);
    return NotificationsSettingsClient;
}());
exports.NotificationsSettingsClient = NotificationsSettingsClient;
/**
 * @overview
 ***Notes:**
 - Refer to the [REST API documentation](https://github.com/Baasic/baasic-rest-api/wiki) for detailed information about available Baasic REST API end-points.
 - All end-point objects are transformed by the associated route service.
 */ 
